import React from 'react';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/46114651766972:1';
export function HeroSection() {
  return <section className="relative bg-neutral-bg py-10 px-4 sm:px-6 lg:px-8 text-center overflow-hidden" data-id="element-44">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-garden-bg/80 via-transparent to-transparent pointer-events-none" data-id="element-45"></div>
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-garden-light/20 rounded-full blur-3xl pointer-events-none" data-id="element-46"></div>
      <div className="absolute top-48 -right-24 w-80 h-80 bg-earth-light/20 rounded-full blur-3xl pointer-events-none" data-id="element-47"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-48">
        <div className="inline-block mb-4" data-id="element-49">
          <p className="text-garden-dark font-bold text-xs sm:text-sm uppercase tracking-widest bg-garden-bg border border-garden-medium/30 px-4 py-1.5 rounded-full shadow-sm" data-id="element-50">
            Para personas que quieren tener su huerta en casa (aunque empiecen
            desde cero)
          </p>
        </div>

        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tight leading-tight mb-6 drop-shadow-sm text-gradient-garden" data-id="element-51">
          EL MANUAL DEL JARDINERO
        </h1>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block mx-auto w-72 sm:w-96 mb-8 transform transition-all duration-500 hover:scale-105 hover:-translate-y-2 cursor-pointer relative group" data-id="element-52">
          <div className="absolute inset-0 bg-garden-medium/20 blur-2xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-53"></div>
          <img src="https://cdn.magicpatterns.com/uploads/1pko7w2khyGYFywCfv6Qi3/Diseno_sin_titulo.png" alt="El Manual del Jardinero - Tu primera huerta paso a paso" className="w-full h-auto drop-shadow-2xl relative z-10" data-id="element-54" />
        </a>

        <h2 className="font-serif text-2xl sm:text-3xl font-bold text-[#1A1A1A] mb-4 text-gradient-garden" data-id="element-55">
          Tu primera huerta paso a paso
        </h2>

        <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-56">
          Todo lo que necesitás para crear, cuidar y mantener tu huerta en casa…
          sin experiencia, sin complicaciones y sin volver a fallar.
        </p>

        <div className="relative inline-block group" data-id="element-57">
          <div className="absolute -inset-1 bg-gradient-to-r from-garden-medium to-garden-dark rounded-full blur opacity-40 group-hover:opacity-75 transition duration-500 animate-pulse-glow" data-id="element-58"></div>
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center bg-gradient-garden hover:from-[#1e3d25] hover:to-garden-dark text-white font-black text-lg sm:text-xl py-4 px-10 sm:px-14 rounded-full shadow-xl transform transition-all duration-300 hover:-translate-y-1" data-id="element-59">
            👉 SÍ, QUIERO EMPEZAR MI HUERTA HOY
          </a>
        </div>

        <p className="mt-5 text-gray-500 text-sm font-semibold flex items-center justify-center gap-2" data-id="element-60">
          <span className="bg-green-100 text-green-700 rounded-full p-0.5 text-xs" data-id="element-61">
            ✅
          </span>{' '}
          Garantía de satisfacción de 7 días
        </p>
      </div>
    </section>;
}